export default __webpack_public_path__ + "static/media/omnes_medium-webfont.50d67b90.ttf";